import { Component, Input } from '@angular/core';
import { Params } from '@angular/router';

/** Eine Brotkrume: mit Route anklickbar, ohne Route nur Text (aktuelle Seite). */
export interface SpsBrotkrume {
  text: string;
  route?: any[];
  query?: Params;
  icon?: string;
}

/**
 * Schlichte Brotkrumen-Zeile für die SPS-Mock-Ansichten:
 * Projekte › Projekt › Liste › Signal.
 */
@Component({
  selector: 'app-sps-breadcrumbs',
  template: `
    <nav class="brotkrumen" aria-label="Pfad">
      <ng-container *ngFor="let k of teile; let letzte = last; let i = index">
        <mat-icon class="trenner" *ngIf="i > 0">chevron_right</mat-icon>

        <a *ngIf="k.route && !letzte" class="krume krume-link" [routerLink]="k.route" [queryParams]="k.query || {}">
          <mat-icon *ngIf="k.icon" inline>{{ k.icon }}</mat-icon>{{ k.text }}
        </a>

        <span *ngIf="!k.route || letzte" class="krume" [class.krume-aktuell]="letzte">
          <mat-icon *ngIf="k.icon" inline>{{ k.icon }}</mat-icon>{{ k.text }}
        </span>
      </ng-container>
    </nav>
  `,
  styles: [`
    .brotkrumen {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 2px;
      min-width: 0;
      margin-top: 2px;
      font-size: 12px;
      color: #888;
    }

    .krume {
      display: inline-flex;
      align-items: center;
      gap: 3px;
      max-width: 260px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .krume mat-icon {
      font-size: 14px;
      width: 14px;
      height: 14px;
    }

    .krume-link {
      color: #1565c0;
      text-decoration: none;
    }

    .krume-link:hover {
      text-decoration: underline;
    }

    .krume-aktuell {
      color: #555;
      font-weight: 500;
    }

    .trenner {
      font-size: 16px;
      width: 16px;
      height: 16px;
      color: #bbb;
    }

    @media (max-width: 600px) {
      .krume {
        max-width: 150px;
      }
    }
  `]
})
export class SpsBreadcrumbsComponent {
  @Input() teile: SpsBrotkrume[] = [];
}
